import type { OrchestratorPerson } from '../services/my-guides-admin-api';

/** Best label for a person: their name, else the email, else a short id. */
export function personLabel(user: Pick<OrchestratorPerson, 'personId' | 'name' | 'email'>): string {
  return user.name || user.email || `${user.personId.slice(0, 8)}…`;
}

export function personInitial(user: Pick<OrchestratorPerson, 'personId' | 'name' | 'email'>): string {
  return personLabel(user).charAt(0).toUpperCase() || '?';
}
